import { CIAM_AUTH_APP_BASE_URLS } from './ciam-config';
import { createCustomerEnvironment } from './customer-environment';

export const environment = createCustomerEnvironment(CIAM_AUTH_APP_BASE_URLS.hft);
